import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Brain, Lock } from 'lucide-react';

export const SecretLogin = () => {
  const { isAuthenticated, isAdmin, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If already logged in as admin, redirect to admin panel
    if (isAuthenticated && isAdmin) {
      navigate('/admin');
    }
  }, [isAuthenticated, isAdmin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md bg-card border-border">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
            <Lock className="w-6 h-6 text-primary" />
          </div>
          <CardTitle className="text-xl">Admin Access</CardTitle>
          <p className="text-sm text-muted-foreground mt-2">
            Restricted area. Authorized personnel only.
          </p>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button
            onClick={login}
            className="w-full h-12 rounded-lg"
            data-testid="admin-login-button"
          >
            <Brain className="w-5 h-5 mr-2" />
            Sign in with Google
          </Button>
          <p className="text-xs text-center text-muted-foreground">
            Only authorized email addresses can access the admin panel.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default SecretLogin;
